/* eslint-disable */

// todo [akamel] [ashish] this is an initial atempt at refactoring the mapper in webapi.js
import _ from 'underscore';
import { fromLegacy } from './enum';

export function operatorMapper(op) {
  var ret = (op || 'Equal');

  switch (ret) {
  case 'Contains':
    ret = 'contains';
    break;
  case 'DoesNotContain':
    ret = 'doesnotcontain';
    break;
  case 'BeginsWith':
    ret = 'startswith';
    break;
  case 'EndsWith':
    ret = 'endswith';
    break;
  case 'Equal':
    ret = 'eq';
    break;
  case 'NotEqual':
    ret = 'neq';
    break;
  case 'Greater':
    ret = 'gt';
    break;
  case 'GreaterOrEqual':
    ret = 'gte';
    break;
  case 'Less':
    ret = 'lt';
    break;
  case 'LessOrEqual':
    ret = 'lte';
    break;
  case 'EnumSelection':
    ret = 'eq';
    break;
  case 'Between':
    ret = ['gte','lte'];
    break;
  }

  return ret;
}

export function columnNameMapper(name, entityType) {
  var ret = name;

  if (/^CustomColumn/.test(name)){
    return 'PerformanceMetrics/' + name;
  }

  switch (name) {
  case 'DisplayBiddingStrategyType':
    return 'DisplayBiddingStrategyType';
  case 'TopImpressionRate':
  case 'PerformanceMetricsTopImpressionRate':
    ret = 'PerformanceMetrics/TopImpressionRate';
    break;
  case 'AbsoluteTopImpressionRate':
  case 'PerformanceMetricsAbsoluteTopImpressionRate':
    ret = 'PerformanceMetrics/AbsoluteTopImpressionRate';
    break;
  case 'ExactMatchImpressionSharePercent':
  case 'PerformanceMetricsExactMatchImpressionSharePercent':
    ret = 'PerformanceMetrics/ExactMatchImpressionSharePercent';
    break;
  case 'TopImpressionSharePercent':
  case 'PerformanceMetricsTopImpressionSharePercent':
    ret = 'PerformanceMetrics/TopImpressionSharePercent';
    break;
  case 'TopISLostToBudgetPercent':
  case 'PerformanceMetricsTopISLostToBudgetPercent':
    ret = 'PerformanceMetrics/TopISLostToBudgetPercent';
    break;
  case 'TopISLostToRankPercent':
  case 'PerformanceMetricsTopISLostToRankPercent':
    ret = 'PerformanceMetrics/TopISLostToRankPercent';
    break;
  case 'AbsoluteTopImpressionSharePercent':
  case 'PerformanceMetricsAbsoluteTopImpressionSharePercent':
    ret = 'PerformanceMetrics/AbsoluteTopImpressionSharePercent';
    break;
  case 'AbsoluteTopISLostToBudgetPercent':
  case 'PerformanceMetricsAbsoluteTopISLostToBudgetPercent':
    ret = 'PerformanceMetrics/AbsoluteTopISLostToBudgetPercent';
    break;
  case 'AbsoluteTopISLostToRankPercent':
  case 'PerformanceMetricsAbsoluteTopISLostToRankPercent':
    ret = 'PerformanceMetrics/AbsoluteTopISLostToRankPercent';
    break;
  case 'Clicks':
  case 'ClickCount':
  case 'PerformanceMetricsClicks':
  case 'PerformanceMetricsClickCount':
    ret = 'PerformanceMetrics/Clicks';
    break;
  case 'Impressions':
  case 'PerformanceMetricsImpressions':
  case 'ImpressionCount':
  case 'PerformanceMetricsImpressionCount':
    ret = 'PerformanceMetrics/Impressions';
    break;
  case 'AveragePosition':
  case 'PerformanceMetricsAveragePosition':
    ret = 'PerformanceMetrics/AveragePosition';
    break;
  case 'TotalSpendAmount':
  case 'TotalEffectiveCost':
  case 'Spend':
  case 'PerformanceMetricsTotalSpendAmount':
  case 'PerformanceMetricsTotalEffectiveCost':
  case 'PerformanceMetricsSpend':
    ret = 'PerformanceMetrics/Spend';
    break;
  case 'ConversionCount':
  case 'Conversions':
  case 'PerformanceMetricsConversionCount':
  case 'PerformanceMetricsConversions':
    ret = 'PerformanceMetrics/Conversions';
    break;
  case 'ConversionsCredit':
  case 'PerformanceMetricsConversionsCredit':
    ret = 'PerformanceMetrics/ConversionsCredit';
    break;
  case 'AllConversions':
  case 'PerformanceMetricsAllConversions':
    ret = 'PerformanceMetrics/AllConversions';
    break;
  case 'AllConversionsCredit':
  case 'PerformanceMetricsAllConversionsCredit':
    ret = 'PerformanceMetrics/AllConversionsCredit';
    break;
  case 'ViewThroughConversions':
  case 'PerformanceMetricsViewThroughConversions':
    ret = 'PerformanceMetrics/ViewThroughConversions';
    break;
  case 'ViewThroughConversionsCredit':
  case 'PerformanceMetricsViewThroughConversionsCredit':
    ret = 'PerformanceMetrics/ViewThroughConversionsCredit';
    break;
  case 'ViewThroughConversionsCPA':
  case 'PerformanceMetricsViewThroughConversionsCPA':
    ret = 'PerformanceMetrics/ViewThroughConversionsCPA';
    break;
  case 'ViewThroughPartialConversionsCPA':
  case 'PerformanceMetricsViewThroughPartialConversionsCPA':
    ret = 'PerformanceMetrics/ViewThroughPartialConversionsCPA';
    break;
  case 'ViewThroughConversionsRate':
  case 'PerformanceMetricsViewThroughConversionsRate':
    ret = 'PerformanceMetrics/ViewThroughConversionsRate';
    break;
  case 'ViewThroughPartialConversionsRate':
  case 'PerformanceMetricsViewThroughPartialConversionsRate':
    ret = 'PerformanceMetrics/ViewThroughPartialConversionsRate';
    break;
  case 'ViewThroughConversionsRevenue':
  case 'PerformanceMetricsViewThroughConversionsRevenue':
    ret = 'PerformanceMetrics/ViewThroughConversionsRevenue';
    break;
  case 'ViewThroughConversionsReturnOnAdSpend':
  case 'PerformanceMetricsViewThroughConversionsReturnOnAdSpend':
    ret = 'PerformanceMetrics/ViewThroughConversionsReturnOnAdSpend';
    break;
  case 'AverageCPM':
  case 'PerformanceMetricsAverageCPM':
    ret = 'PerformanceMetrics/AverageCPM';
    break;
  case 'AverageCPC':
  case 'PerformanceMetricsAverageCPC':
    ret = 'PerformanceMetrics/AverageCPC';
    break;
  case 'CPA':
  case 'PerformanceMetricsCPA':
    ret = 'PerformanceMetrics/CPA';
    break;
  case 'PartialConversionCPA':
  case 'PerformanceMetricsPartialConversionCPA':
    ret = 'PerformanceMetrics/PartialConversionCPA';
    break;
  case 'AllConversionCPA':
  case 'PerformanceMetricsAllConversionCPA':
    ret = 'PerformanceMetrics/AllConversionCPA';
    break;
  case 'AllPartialConversionCPA':
  case 'PerformanceMetricsAllPartialConversionCPA':
    ret = 'PerformanceMetrics/AllPartialConversionCPA';
    break;
  case 'ConversionRate':
  case 'PerformanceMetricsConversionRate':
    ret = 'PerformanceMetrics/ConversionRate';
    break;
  case 'PartialConversionRate':
  case 'PerformanceMetricsPartialConversionRate':
    ret = 'PerformanceMetrics/PartialConversionRate';
    break;
  case 'AllConversionRate':
  case 'PerformanceMetricsAllConversionRate':
    ret = 'PerformanceMetrics/AllConversionRate';
    break;
  case 'AllPartialConversionRate':
  case 'PerformanceMetricsAllPartialConversionRate':
    ret = 'PerformanceMetrics/AllPartialConversionRate';
    break;
  case 'RevenueOnAdSpend':
  case 'PerformanceMetricsRevenueOnAdSpend':
    ret = 'PerformanceMetrics/RevenueOnAdSpend';
    break;
  case 'AllConversionRevenueOnAdSpend':
  case 'PerformanceMetricsAllConversionRevenueOnAdSpend':
    ret = 'PerformanceMetrics/AllConversionRevenueOnAdSpend';
    break;
  case 'AdvertiserReportedRevenue':
  case 'PerformanceMetricsAdvertiserReportedRevenue':
    ret = 'PerformanceMetrics/AdvertiserReportedRevenue';
    break;
  case 'AllConversionAdvertiserReportedRevenue':
  case 'PerformanceMetricsAllConversionAdvertiserReportedRevenue':
    ret = 'PerformanceMetrics/AllConversionAdvertiserReportedRevenue';
    break;
  case 'ClickThrough':
  case 'CTR':
  case 'PerformanceMetricsClickThrough':
  case 'PerformanceMetricsCTR':
    ret = 'PerformanceMetrics/CTR';
    break;
  case 'ImpShare':
  case 'PerformanceMetricsImpShare':
    ret= 'PerformanceMetrics/AuctionWonPercent';
    break;
  case 'ImpShareLostToBudget':
  case 'PerformanceMetricsImpShareLostToBudget':
    ret= 'PerformanceMetrics/AuctionLostToBudgetPercent';
    break;
  case 'ImpShareLostToBid':
  case 'PerformanceMetricsImpShareLostToBid':
    ret= 'PerformanceMetrics/AuctionLostToBidPercent';
    break;
  case 'ImpShareLostToExpectedCTR':
  case 'PerformanceMetricsImpShareLostToExpectedCTR':
    ret= 'PerformanceMetrics/AuctionLostToAdQualityPercent';
    break;
  case 'ImpShareLostToRank':
  case 'PerformanceMetricsImpShareLostToRank':
    ret= 'PerformanceMetrics/AuctionLostToRankPercent';
    break;
  case 'ImpShareLostToAdRelevance':
  case 'PerformanceMetricsImpShareLostToAdRelevance':
    ret= 'PerformanceMetrics/AuctionLostToLandingPercent';
    break;
  case 'ClickShare':
  case 'PerformanceMetricsClickShare':
    ret= 'PerformanceMetrics/ClickSharePercent';
    break;
  case 'ClickSharePercent':
  case 'PerformanceMetricsClickSharePercent':
    ret= 'PerformanceMetrics/ClickSharePercent';
    break;
  case 'AuctionWonPercent':
  case 'PerformanceMetricsAuctionWonPercent':
    ret= 'PerformanceMetrics/AuctionWonPercent';
    break;
  case 'AuctionLostToBudgetPercent':
  case 'PerformanceMetricsAuctionLostToBudgetPercent':
    ret= 'PerformanceMetrics/AuctionLostToBudgetPercent';
    break;
  case 'AuctionLostToBidPercent':
  case 'PerformanceMetricsAuctionLostToBidPercent':
    ret= 'PerformanceMetrics/AuctionLostToBidPercent';
    break;
  case 'AuctionLostToAdQualityPercent':
  case 'PerformanceMetricsAuctionLostToAdQualityPercent':
    ret= 'PerformanceMetrics/AuctionLostToAdQualityPercent';
    break;
  case 'AuctionLostToRankPercent':
  case 'PerformanceMetricsAuctionLostToRankPercent':
    ret= 'PerformanceMetrics/AuctionLostToRankPercent';
    break;
  case 'AuctionLostToLandingPercent':
  case 'PerformanceMetricsAuctionLostToLandingPercent':
    ret= 'PerformanceMetrics/AuctionLostToLandingPercent';
    break;
  case 'ClickSharePercent':
  case 'PerformanceMetricsClickSharePercent':
    ret= 'PerformanceMetrics/ClickSharePercent';
    break;
  case 'FirstPageBidEstimation':
  case 'FirstPageBid':
    ret = 'BidEstimate/FirstPageBidEstimation';
    break;
  case 'MainlineBidEstimation':
  case 'MainlineBid':
    ret = 'BidEstimate/MainlineBidEstimation';
    break;
  case 'BestPositionBidEstimation':
  case 'BestPositionBid':
    ret = 'BidEstimate/BestPositionBidEstimation';
    break;
  case 'AverageCPP':
  case 'PhonePerformanceMetricsAverageCPP':
    ret = 'PhonePerformanceMetrics/AverageCPP';
    break;
  case 'ClickCalls':
  case 'PhonePerformanceMetricsClickCalls':
    ret = 'PhonePerformanceMetrics/ClickCalls';
    break;
  case 'ManualCalls':
  case 'PhonePerformanceMetricsManualCalls':
    ret = 'PhonePerformanceMetrics/ManualCalls';
    break;
  case 'PhoneImpressions':
  case 'PhonePerformanceMetricsPhoneImpressions':
    ret = 'PhonePerformanceMetrics/PhoneImpressions';
    break;
  case 'PhoneCalls':
  case 'PhonePerformanceMetricsPhoneCalls':
    ret = 'PhonePerformanceMetrics/PhoneCalls';
    break;
  case 'TotalCost':
  case 'ClickAndPhoneSpent':
  case 'PhonePerformanceMetricsTotalCost':
  case 'PhonePerformanceMetricsClickAndPhoneSpent':
    ret = 'PhonePerformanceMetrics/ClickAndPhoneSpend';
    break;
  case 'PhoneThroughRate':
  case 'PhonePerformanceMetricsPhoneThroughRate':
  case 'PhonePerformanceMetricsPTR':
    ret = 'PhonePerformanceMetrics/PTR';
    break;
  case 'PhoneCost':
  case 'PhoneSpent':
  case 'PhonePerformanceMetricsPhoneCost':
  case 'PhonePerformanceMetricsPhoneSpent':
    ret = 'PhonePerformanceMetrics/PhoneSpend';
    break;
  case 'KeywordName':
    ret = 'Text';
    break;
  case 'CampaignStatus':
    switch (entityType) {
    case 'Campaign':
      ret = 'Status';
      break;
    case 'ProductGroup':
      ret = 'CampaignStatus';
      break;
    default:
      ret = 'Campaign/Status';
      break;
    }
    break;
  case 'AdGroupStatus':
    switch (entityType) {
    case 'AdGroup':
    case 'AdGroups':
      ret = 'Status';
      break;
    default:
      ret = 'AdGroup/Status';
      break;
    }
    break;
  case 'StatusIcon':
  case 'KeywordStatus':
  case 'AdUiDisplayStatus':
    ret = 'Status';
    break;
  case 'ID':
  case 'CampaignId':
  case 'KeywordId':
  case 'AdId':
  case 'AdGroupId':
  case 'AssetGroupId':
  case 'AudienceAssociationId':
  case 'OrderItemId':
    ret = 'Id';
    break;
  case 'AudienceId':
    switch (entityType) {
      case 'AudienceAssociation':
      case 'AdGroupAudienceAssociation':
        ret = 'AudienceCriterion/AudienceId';
        break;
    }
    break;
  case 'AudienceType':
    switch (entityType) {
      case 'AudienceAssociation':
      case 'AdGroupAudienceAssociation':
        ret = 'AudienceCriterion/AudienceType';
        break;
    }
    break;
  case 'AudienceName':
    switch (entityType) {
      case 'AudienceAssociation':
      case 'AdGroupAudienceAssociation':
        ret = 'AudienceCriterion/AudienceName';
        break;
    }
    break;
  case 'BidMultiplier':
    switch (entityType) {
      case 'AudienceAssociation':
      case 'AdGroupAudienceAssociation':
        ret = 'AudienceCriterion/BidMultiplier';
        break;
    }
    break;
  case 'AdExtensionId':
    ret = 'AdExtension/Id';
    break;
  case 'DeliveryStatusView':
  case 'DeliveryStatus':
  switch (entityType) {
    case 'AdExtensionAssociation':
      ret = 'AdExtension/Delivery';
      break;
    default:
      ret = 'DeliveryStatus';
      break;
    }
    break;
  case 'MatchType':
    ret = 'MatchType';
    break;
  case 'QualityScore':
    ret = 'QualityScore/OverallQualityScore';
    break;
  case 'Bid':
  case 'OrderItemBid':
    ret = 'Bid/Amount';
    break;
  case 'Campaign':
  case 'CampaignName':
  case 'AdExtensionCampaignName':
    switch (entityType) {
      case 'Campaign':
        ret = 'Name';
        break;
      case 'Keyword':
      case 'Ad':
      case 'AdGroup':
      case 'AdGroups':
      case 'AudienceAssociation':
      case 'AdGroupAudienceAssociation':
      case 'AdExtensionAssociation':
        ret = 'Campaign/Name';
        break;
    }
    break;
  case 'AdExtensionCampaignAssociationStatus':
  case 'AdExtensionAssociationStatus':
    ret = 'AdExtension/Status';
    break;
  case 'AdGroup':
  case 'KeywordAdGroupName':
case 'AdAdGroupName':
  case 'AdExtensionAdGroupName':
    ret = 'AdGroup/Name';
    break;
  case 'KeywordIsLastImported':
  case 'CampaignIsLastImported':
  case 'AdGroupIsLastImported':
  case 'AdIsLastImported':
    ret = 'UpdatedOnLastImport';
    break;
  case 'BudgetType':
    ret = 'Budget/Type';
    break;
  case 'CampaignBudgetAmount':
  case 'CombinedBudget':
  case 'Budget':
    ret = 'Budget/Amount';
    break;
  case 'AdGroupCashbackPercent':
    ret = 'AdGroupCashback/Percent';
    break;
  case 'AdGroupCashbackScope':
    ret = 'AdGroupCashback/Scope';
    break;
  case 'ProductGroupCashbackPercent':
    ret = 'ProductGroupCashback/Percent';
    break;
  case 'ProductGroupCashbackScope':
    ret = 'ProductGroupCashback/Scope';
    break;
  case 'CampaignCashbackPercent':
    ret = 'CampaignCashback/Percent';
    break;
  case 'CampaignCashbackScope':
    ret = 'CampaignCashback/Scope';
    break;
  case 'CampaignCashbackMonthlyBudget':
    ret = 'CampaignCashback/MonthlyBudget';
    break;
  case 'AudienceCriterionCashbackAdjustment':
    ret = 'AudienceCriterion/CashbackAdjustment';
    break;
  case 'AdType':
    ret = 'Type';
    break;
  case 'AdsByBing':
    ret = 'AdsByBing';
    break;
  case 'AdStrength':
    ret = 'AdStrength';
    break;
  case 'AdTitle':
    switch (entityType) {
    case 'AdExtensionAssociation':
      ret = 'AdExtension';
      break;
    default:
      ret = 'Title';
      break;
    }
    break;
  case 'AdDescription':
    ret = 'TitleOrText';
    break;
  case 'AdDestinationUrl':
    ret = 'DestinationUrl';
    break;
  case 'AdDisplayUrl':
    ret = 'DisplayUrl';
    break;
  case 'FormattedMedium':
    ret = 'Medium';
    break;
  case 'AdGroupName':
    switch (entityType) {
      case 'AdGroup':
      case 'AdGroups':
        ret = 'Name';
        break;
      default:
        ret = 'AdGroup/Name';
        break;
      }
    break;
  case 'Bidding.BroadBid':
  case 'AdGroupDefaultSearchBid':
    ret = 'SearchBid';
    break;
  case 'Bidding.ContentBid':
  case 'AdGroupDefaultContentBid':
    ret = 'ContentBid';
    break;
  case 'AdGroupCallTrackingStatus':
    ret = 'CallTrackingStatus';
    break;
  case 'AdGroupEndDate':
    switch (entityType) {
      case 'AdExtensionAssociation':
        ret = 'AdExtension/Scheduling/EndDate';
        break;
      default:
        ret = 'EndDate';
        break;
      }
    break;
  case 'AdGroupStartDate':
    switch (entityType) {
      case 'AdExtensionAssociation':
        ret = 'AdExtension/Scheduling/StartDate';
        break;
      default:
        ret = 'StartDate';
        break;
      }
    break;
  case 'AdExtensionEndDate':
    ret = 'AdExtension/Scheduling/EndDate';
    break;
  case 'AdExtensionStartDate':
    ret = 'AdExtension/Scheduling/StartDate';
    break;
  case 'AdExtensionSchedule':
    ret = 'AdExtension/Scheduling/DayTimeRanges';
    break;
  case 'AdExtensionTimeZone':
    ret = 'AdExtension/Scheduling/UseSearcherTimeZone';
    break;
  case 'AudienceName':
    ret = 'AudienceCriterion/AudienceName';
    break;
  case 'AudienceType':
    ret = 'AudienceCriterion/AudienceType';
    break;
  case 'AudienceStatus':
    ret = 'Status';
    break;
  case 'BidMultiplier':
    ret = 'AudienceCriterion/BidMultiplier';
    break;
  case 'BidType':
    ret = 'BidType';
    break;
  case 'AssociationState':
    ret = 'AdExtension/Status';
    break;
  case 'FinalUrlJson':
    ret = 'FinalUrls';
    break;
  case 'UrlCustomParametersJson':
    ret = 'UrlCustomParameters';
    break;
  case 'TrackingTemplateJson':
  case 'TrackingTemplate':
    ret = 'TrackingUrlTemplate';
    break;
  case 'Type':
    ret = 'BiddingScheme/Type';
    break;
  case 'CampaignCampaignType':
    switch (entityType) {
      case 'Campaign':
        ret = 'CampaignType';
        break;
      default:
        ret = 'Campaign/CampaignType';
        break;
    }
    break;
  case 'CampaignLanguages':
    ret = 'Languages';
    break;
  }

  return ret;
}

export function columnTypeMapper(name) {
  var ret = 'string';
  switch (name) {
  case 'KeywordName':
  case 'CampaignName':
  case 'KeywordAdGroupName':
  case 'AdAdGroupName':
    ret = 'string';
    break;
  case 'FinalUrls':
  case 'MobileFinalUrls':
    ret = 'stringEnum';
  case 'BudgetType':
  case 'StatusIcon':
  case 'CampaignStatus':
  case 'KeywordStatus':
  case 'AdUiDisplayStatus':
  case 'AdGroupStatus':
  case 'MatchType':
  case 'DeliveryStatus':
  case 'AdType':
  case 'AdGroupCallTrackingStatus':
  case 'FormattedMedium':
  case 'DevicePreference':
  case 'AudienceStatus':
  case 'CampaignCampaignType':
  case 'DisplayBiddingStrategyType':
  case 'BidType':
  case 'AudienceType':
  case 'CampaignLanguages':
  case 'Language':
  case 'Languages':
  case 'Level':
    ret = 'enum';
    break;
  case 'KeywordId':
  case 'CampaignId':
  case 'AdId':
  case 'AdGroupId':
  case 'AdExtensionId':
  case 'AudienceAssociationId':
  case 'Clicks':
  case 'Impressions':
  case 'AveragePosition':
  case 'TotalEffectiveCost':
  case 'Spend':
  case 'Conversions':
  case 'ConversionsCredit':
  case 'AverageCPM':
  case 'AverageCPC':
  case 'CPA':
  case 'PartialConversionCPA':
  case 'ConversionRate':
  case 'PartialConversionRate':
  case 'RevenueOnAdSpend':
  case 'AdvertiserReportedRevenue':
  case 'AllConversionCPA':
  case 'AllPartialConversionCPA':
  case 'AllConversions':
  case 'AllConversionsCredit':
  case 'AllConversionRate':
  case 'AllPartialConversionRate':
  case 'AllConversionAdvertiserReportedRevenue':
  case 'AllConversionRevenueOnAdSpend':
  case 'ViewThroughConversions':
  case 'ViewThroughConversionsCredit':
  case 'ViewThroughConversionsCPA':
  case 'ViewThroughPartialConversionsCPA':
  case 'ViewThroughConversionsRate':
  case 'ViewThroughPartialConversionsRate':
  case 'ViewThroughConversionsRevenue':
  case 'ViewThroughConversionsReturnOnAdSpend':
  case 'ImpShare':
  case 'ImpShareLostToBudget':
  case 'ImpShareLostToRank':
  case 'ImpShareLostToAdRelevance':
  case 'ImpShareLostToExpectedCTR':
  case 'ImpShareLostToBid':
  case 'ClickShare':
  case 'AuctionWonPercent':
  case 'AuctionLostToBudgetPercent':
  case 'AuctionLostToBidPercent':
  case 'AuctionLostToAdQualityPercent':
  case 'AuctionLostToRankPercent':
  case 'AuctionLostToLandingPercent':
  case 'ClickSharePercent':
  case 'TopImpressionRate':
  case 'AbsoluteTopImpressionRate':
  case 'ExactMatchImpressionSharePercent':
  case 'TopImpressionSharePercent':
  case 'TopISLostToBudgetPercent':
  case 'TopISLostToRankPercent':
  case 'AbsoluteTopImpressionSharePercent':
  case 'AbsoluteTopISLostToBudgetPercent':
  case 'AbsoluteTopISLostToRankPercent':
  case 'CTR':
  case 'PerformanceMetricsClicks':
  case 'PerformanceMetricsImpressions':
  case 'PerformanceMetricsAveragePosition':
  case 'PerformanceMetricsTotalEffectiveCost':
  case 'PerformanceMetricsSpend':
  case 'PerformanceMetricsConversions':
  case 'PerformanceMetricsConversionsCredit':
  case 'PerformanceMetricsAverageCPM':
  case 'PerformanceMetricsAverageCPC':
  case 'PerformanceMetricsCPA':
  case 'PerformanceMetricsPartialConversionCPA':
  case 'PerformanceMetricsConversionRate':
  case 'PerformanceMetricsPartialConversionRate':
  case 'PerformanceMetricsRevenueOnAdSpend':
  case 'PerformanceMetricsAdvertiserReportedRevenue':
  case 'PerformanceMetricsAllConversionCPA':
  case 'PerformanceMetricsAllPartialConversionCPA':
  case 'PerformanceMetricsAllConversions':
  case 'PerformanceMetricsAllConversionsCredit':
  case 'PerformanceMetricsAllConversionRate':
  case 'PerformanceMetricsAllPartialConversionRate':
  case 'PerformanceMetricsAllConversionAdvertiserReportedRevenue':
  case 'PerformanceMetricsAllConversionRevenueOnAdSpend':
  case 'PerformanceMetricsImpShare':
  case 'PerformanceMetricsImpShareLostToBudget':
  case 'PerformanceMetricsImpShareLostToRank':
  case 'PerformanceMetricsImpShareLostToAdRelevance':
  case 'PerformanceMetricsImpShareLostToExpectedCTR':
  case 'PerformanceMetricsImpShareLostToBid':
  case 'PerformanceMetricsClickShare':
  case 'PerformanceMetricsAuctionWonPercent':
  case 'PerformanceMetricsAuctionLostToBudgetPercent':
  case 'PerformanceMetricsAuctionLostToBidPercent':
  case 'PerformanceMetricsAuctionLostToAdQualityPercent':
  case 'PerformanceMetricsAuctionLostToRankPercent':
  case 'PerformanceMetricsAuctionLostToLandingPercent':
  case 'PerformanceMetricsClickSharePercent':
  case 'PerformanceMetricsCTR':
  case 'PerformanceMetricsViewThroughConversions':
  case 'PerformanceMetricsViewThroughConversionsCredit':
  case 'PerformanceMetricsViewThroughConversionsCPA':
  case 'PerformanceMetricsViewThroughPartialConversionsCPA':
  case 'PerformanceMetricsViewThroughConversionsRate':
  case 'PerformanceMetricsViewThroughPartialConversionsRate':
  case 'PerformanceMetricsViewThroughConversionsRevenue':
  case 'PerformanceMetricsViewThroughConversionsReturnOnAdSpend':
  case 'FirstPageBid':
  case 'MainlineBid':
  case 'BestPositionBid':
  case 'OrderItemBid':
  case 'QualityScore':
  case 'AdGroupDefaultSearchBid':
  case 'AdGroupDefaultContentBid':
  case 'CampaignBudgetAmount':
  case 'OrderItemId':
  case 'Labels':
    ret = 'number';
    break;
  case 'KeywordIsLastImported':
  case 'CampaignIsLastImported':
  case 'AdIsLastImported':
  case 'AdGroupIsLastImported':
  case 'HasAuctionInsight':
  case 'AdStrength':
  case 'AdsByBing':
    ret = 'bool';
    break;
  case 'AdGroupStartDate':
  case 'AdGroupEndDate':
    ret = 'date';
    break;
  case 'AdExtensionCampaignAssociationStatus':
  case 'AdExtensionAssociationStatus':
    ret = 'enum';
    break;
  }

  return ret;
}

export function valueFormatter(value, type, columnName, entityType, decimal) {
  switch (type) {
  case 'number':
    return isNaN(Number(value)) ? decimal.fromLocalToFloat(value) : Number(value);
  case 'bool':
    //UI server side will serialize value as "1" instead of 1 in certain scenarios, so use == for that check
    return value === true || value == 1;
  case 'enum':
    return this.enumMapper[columnName](value, entityType);
  default:
    return value;
  }
}

export function lambdaMapper(operator, columnName, entityType, values) {
  if (_.isEmpty(operator)) {
    return null;
  }

  switch (operator.toLowerCase()) {
    case 'containsany':
      return {
        logic: 'or',
        mapToShorterVersion: true,
        secondLogic: 'any',
        fieldId: this.lambadaFieldIdMapping(columnName, entityType),
        operator: 'eq',
      }
    case 'containsall':
      return {
        logic: 'and',
        mapToShorterVersion: false,
        secondLogic: 'any',
        fieldId: 'd:' + this.lambadaFieldIdMapping(columnName, entityType),
        operator: 'eq',
      }
    case 'containsnone':
      return {
        logic: 'and',
        mapToShorterVersion: true,
        secondLogic: 'all',
        fieldId: this.lambadaFieldIdMapping(columnName, entityType),
        operator: 'ne',
      }
    case 'contains':
      if (_.contains(['finalurls', 'mobilefinalurls'], columnName.toLowerCase())) {
        return {
          logic: 'and',
          mapToShorterVersion: false,
          secondLogic: 'any',
          fieldId: 'd:contains(d,\'' + values[0] + '\')',
          operator: '',
          value: '',
        }
      } else {
        return null;
      };

  case 'doesnotcontain':
    if (_.contains(['finalurls', 'mobilefinalurls'], columnName.toLowerCase())) {
        return {
          logic: 'and',
          mapToShorterVersion: false,
          secondLogic: 'any',
          fieldId: 'd:contains(d,\'' + values[0] + '\')',
          operator: 'eq',
          value: 'false',
        }
      } else {
        return null;
      };
    default:
      return null;
  }
}

export function lambadaFieldIdMapping(columnName, entityType) {
  switch (columnName) {
    case 'Labels':
      return 'd/Id';
  case 'CampaignLanguages':
  case 'Languages':
      return 'd';
    default:
      return columnName;
  }
}
export const enumMapper = {
  'Level': function (value) {
    return 'Enum.AudienceCriterionLevel\'' + value + '\'';
  },
  'Languages':  function (value) {
    if (value.indexOf('Enum.Language') < 0) {
      return 'Enum.Language\'' + value + '\'';
    }
    return value;
  },
  'Language':  function (value) {
    if (value !== null && value.indexOf('Enum.Language') < 0) {
      if (_.isNaN(Number(value))) {
        return 'Enum.Language\'' + value + '\'';
      }

      return fromLegacy(value, 'Language');
    }
    return value;
  },
  'BiddingScheme/Type': function (value) {
    return fromLegacy(value, 'BiddingStrategyType');
  },
  'DisplayBiddingStrategyType': function (value) {
    return fromLegacy(value, 'BiddingStrategyType');
  },
  'BidType': function(value) {
    switch(value) {
      case '0':
        return 'Enum.BidType\'BidOnly\'';
      case '1':
        return 'Enum.BidType\'TargetAndBid\'';
    }
  },
  'AudienceCriterion/AudienceType': function(value) {
    return "Enum.AudienceType'" + value + "'";
  },
  'Campaign/CampaignType': function (value) {
    return fromLegacy(value, 'CampaignType');
  },
  CampaignType: function (value) {
    return fromLegacy(value, 'CampaignType');
  },
  CallTrackingStatus: function (value) {
    return fromLegacy(value, 'AdGroupCallTrackingStatus');
  },
  'Budget/Type': function (value) {
    switch (value) {
    case '0':
    case 'Monthly':
      return 'Enum.BudgetType\'Monthly\'';
    case '1':
    case 'DailyStandard':
      return 'Enum.BudgetType\'DailyStandard\'';
    case '2':
    case 'DailyAccelerated':
      return 'Enum.BudgetType\'DailyAccelerated\'';
    case '3':
    case 'LifetimeBudgetStandard':
      return 'Enum.BudgetType\'LifetimeBudgetStandard\'';
    }
  },
  'Medium': function (value) {
    var result = fromLegacy(value, 'Medium');
    if (result) return result;
    switch (value) {
    case 'Search':
      return 'Enum.Medium\'Search\'';
    case 'Content':
      return 'Enum.Medium\'Content\'';
    case 'SearchAndContent':
      return 'Enum.Medium\'SearchAndContent\'';
      case 'Audience':
      return 'Enum.Medium\'Audience\'';
    }
  },
  Type: function (value) {
    switch (value) {
    case '1':
    case 'Text':
      return 'Enum.AdType\'Text\'';
    case '2':
      return 'Enum.AdType\'Mobile\'';
    case '4':
      return 'Enum.AdType\'BannerImage\'';
    case '8':
      return 'Enum.AdType\'CPAAd\'';
    case '16':
      return 'Enum.AdType\'RichMedia\'';
    case '32':
      return 'Enum.AdType\'ThirdPartyServedAsset\'';
    case '64':
      return 'Enum.AdType\'RichSearchAd\'';
    case '128':
      return 'Enum.AdType\'Product\'';
    case '256':
    case 'AppInstall':
      return 'Enum.AdType\'AppInstall\'';
    case '512':
      return 'Enum.AdType\'DynamicSearch\'';
    case '1024':
    case 'ExpandedText':
      return 'Enum.AdType\'ExpandedText\'';
    case '4096':
    case 'Responsive':
      return 'Enum.AdType\'Responsive\'';
    case '8192':
    case 'ResponsiveSearch':
      return 'Enum.AdType\'ResponsiveSearch\'';
    }
  },
  DevicePreference: function (value) {
    switch (value) {
    case '0':
    case 'All':
      return 'Enum.DevicePreference\'All\'';
    case '2':
    case 'Mobile':
      return 'Enum.DevicePreference\'Mobile\'';
    }
  },
  MatchType: function (value) {
    switch (value) {
    case '1':
      return 'Enum.MatchType\'Exact\'';
    case '2':
      return 'Enum.MatchType\'Phrase\'';
    case '3':
      return 'Enum.MatchType\'Broad\'';
    case '5':
      return 'Enum.MatchType\'Content\'';
    }
  },
  DeliveredMatchType: function (value) {
    switch (value) {
    case '1':
      return 'Enum.MatchType\'Exact\'';
    case '2':
      return 'Enum.MatchType\'Phrase\'';
    case '3':
      return 'Enum.MatchType\'Broad\'';
    case '5':
      return 'Enum.MatchType\'Content\'';
    }
  },
  SearchTermStatus: function (value) {
    switch (value) {
    case '0':
      return 'Enum.SearchTermStatus\'None\'';
    case '1':
      return 'Enum.SearchTermStatus\'Added\'';
    case '2':
      return 'Enum.SearchTermStatus\'Excluded\'';
    case '3':
      return 'Enum.SearchTermStatus\'Added,Excluded\'';
    }
  },
  'AdExtension/Delivery': function (value) {
      switch (value) {
      case '40':
      case 'InvalidFinancialStatusOther':
        return 'Enum.DeliveryStatus\'InvalidFinancialStatusOther\'';
      case '48':
      case 'CampaignDeleted':
        return 'Enum.DeliveryStatus\'CampaignDeleted\'';
      case '49':
      case 'CampaignSuspended':
        return 'Enum.DeliveryStatus\'CampaignSuspended\'';
      case '50':
      case 'CampaignBudgetPaused':
        return 'Enum.DeliveryStatus\'CampaignBudgetPaused\'';
      case '70':
      case 'EditorialRejected':
        return 'Enum.DeliveryStatus\'EditorialRejected\'';
      case '75':
        return 'Enum.DeliveryStatus\'EditorialUnderAppeal\'';
      case '80':
      case 'EditorialPending':
        return 'Enum.DeliveryStatus\'EditorialPending\'';
      case '85':
      case 'AssociationDeleted':
        return 'Enum.DeliveryStatus\'AssociationDeleted\'';
      case '90':
      case 'CampaignUserPaused':
        return 'Enum.DeliveryStatus\'CampaignUserPaused\'';
      case '200':
      case 'EditorialApprovedLimited':
        return 'Enum.DeliveryStatus\'EditorialApprovedLimited\'';
      case '2147483647':
      case 'Eligible':
        return 'Enum.DeliveryStatus\'Eligible\'';
    }
  },
  DeliveryStatus: function (value) {
    var result = fromLegacy(value, 'DeliveryStatus');

    if (result) return result;

    switch (value) {
      case 'CreditCardExpired':
        return 'Enum.DeliveryStatus\'CreditCardExpired\'';
      case 'IOExceeded':
        return 'Enum.DeliveryStatus\'IOExceeded\'';
      case 'PaymentInformationMissing':
        return 'Enum.DeliveryStatus\'PaymentInformationMissing\'';
      case 'InvalidFinancialStatusOther':
        return 'Enum.DeliveryStatus\'InvalidFinancialStatusOther\'';
      case 'MigrationPaused':
        return 'Enum.DeliveryStatus\'MigrationPaused\'';
      case 'CampaignDeleted':
        return 'Enum.DeliveryStatus\'CampaignDeleted\'';
      case 'CampaignSuspended':
        return 'Enum.DeliveryStatus\'CampaignSuspended\'';
      case 'CampaignBudgetPaused':
        return 'Enum.DeliveryStatus\'CampaignBudgetPaused\'';
      case 'AdGroupExpired':
        return 'Enum.DeliveryStatus\'AdGroupExpired\'';
      case 'AdGroupDraft':
        return 'Enum.DeliveryStatus\'AdGroupDraft\'';
      case 'AdGroupDeleted':
        return 'Enum.DeliveryStatus\'AdGroupDeleted\'';
      case 'CamAssetRejected':
        return 'Enum.DeliveryStatus\'CamAssetRejected\'';
      case 'CamAssetDeleted':
        return 'Enum.DeliveryStatus\'CamAssetDeleted\'';
      case 'AdGroupTargetingTooNarrow':
        return 'Enum.DeliveryStatus\'AdGroupTargetingTooNarrow\'';
      case 'EditorialRejected':
        return 'Enum.DeliveryStatus\'EditorialRejected\'';
      case 'EditorialAppealRejected':
        return 'Enum.DeliveryStatus\'EditorialAppealRejected\'';
      case 'EditorialPending':
        return 'Enum.DeliveryStatus\'EditorialPending\'';
      case 'AssociationDeleted':
        return 'Enum.DeliveryStatus\'AssociationDeleted\'';
      case 'CampaignUserPaused':
        return 'Enum.DeliveryStatus\'CampaignUserPaused\'';
      case 'AdGroupPrivacyPending':
        return 'Enum.DeliveryStatus\'AdGroupPrivacyPending\'';
      case 'AdGroupUserPaused':
        return 'Enum.DeliveryStatus\'AdGroupUserPaused\'';
      case 'AdUserPaused':
        return 'Enum.DeliveryStatus\'AdUserPaused\'';
      case 'KeywordMatchTypeAdGroupMediumCombinationInvalid':
        return 'Enum.DeliveryStatus\'KeywordMatchTypeAdGroupMediumCombinationInvalid\'';
      case 'KeywordUserPaused':
        return 'Enum.DeliveryStatus\'KeywordUserPaused\'';
      case 'NegativeKeywordConflicts':
        return 'Enum.DeliveryStatus\'NegativeKeywordConflicts\'';
      case 'PartialNegativeKeywordConflicts':
        return 'Enum.DeliveryStatus\'PartialNegativeKeywordConflicts\'';
      case 'EditorialApprovedLimited':
        return 'Enum.DeliveryStatus\'EditorialApprovedLimited\'';
      case 'EditorialApprovedLimitedAppealRejected':
        return 'Enum.DeliveryStatus\'EditorialApprovedLimitedAppealRejected\'';
      case 'LowSupply':
        return 'Enum.DeliveryStatus\'LowSupply\'';
      case 'LowQuality':
        return 'Enum.DeliveryStatus\'LowQuality\'';
      case 'BidBelowFirstPageBid':
        return 'Enum.DeliveryStatus\'BidBelowFirstPageBid\'';
      case 'Incomplete':
        return 'Enum.DeliveryStatus\'Incomplete\'';
      case 'BudgetSuggestions':
        return 'Enum.DeliveryStatus\'BudgetSuggestions\'';
      case 'InlineOpportunity':
        return 'Enum.DeliveryStatus\'InlineOpportunity\'';
      case 'GeoCodingIncomplete':
        return 'Enum.DeliveryStatus\'GeoCodingIncomplete\'';
      case 'ProductTargetUserPaused':
        return 'Enum.DeliveryStatus\'ProductTargetUserPaused\'';
      case 'AdExtensionNotPresent':
        return 'Enum.DeliveryStatus\'AdExtensionNotPresent\'';
      case 'AdExtensionDeleted':
        return 'Enum.DeliveryStatus\'AdExtensionDeleted\'';
      case 'AdExtensionAssociationDeleted':
        return 'Enum.DeliveryStatus\'AdExtensionAssociationDeleted\'';
      case 'StoreIdNotAssociated':
        return 'Enum.DeliveryStatus\'StoreIdNotAssociated\'';
      case 'AdGroupAudienceAssociationPaused':
        return 'Enum.DeliveryStatus\'AdGroupAudienceAssociationPaused\'';
      case 'AdGroupAudienceAssociationExcluded':
        return 'Enum.DeliveryStatus\'AdGroupAudienceAssociationExcluded\'';
      case 'AdNotPresent':
        return 'Enum.DeliveryStatus\'AdNotPresent\'';
      case 'AdNotActive':
        return 'Enum.DeliveryStatus\'AdNotActive\'';
      case 'UrlInvalid':
        return 'Enum.DeliveryStatus\'UrlInvalid\'';
      case 'ApplicationNotFound':
        return 'Enum.DeliveryStatus\'ApplicationNotFound\'';
      case 'ApplicationDestinationUrlMismatch':
        return 'Enum.DeliveryStatus\'ApplicationDestinationUrlMismatch\'';
      case 'PendingMetadataSync':
        return 'Enum.DeliveryStatus\'PendingMetadataSync\'';
      case 'ApplicationDestinationUrlValidationIncomplete':
        return 'Enum.DeliveryStatus\'ApplicationDestinationUrlValidationIncomplete\'';
      case 'AutoBiddingLimitedInventoryLimit':
        return 'Enum.DeliveryStatus\'AutoBiddingLimitedInventoryLimit\'';
      case 'AutoBiddingLimitedMaxCPCRestriction':
        return 'Enum.DeliveryStatus\'AutoBiddingLimitedMaxCPCRestriction\'';
      case 'AutoBiddingLimitedBudgetRestriction':
        return 'Enum.DeliveryStatus\'AutoBiddingLimitedBudgetRestriction\'';
      case 'AutoBiddingLimitedUnAttainableTarget':
        return 'Enum.DeliveryStatus\'AutoBiddingLimitedUnAttainableTarget\'';
      case 'AutoBiddingPortfolioBidStrategyTrainingStatus':
        return 'Enum.DeliveryStatus\'AutoBiddingPortfolioBidStrategyTrainingStatus\'';
      case 'Eligible':
        return 'Enum.DeliveryStatus\'Eligible\'';
    }
  },
  AdStrength: function (value) {
    switch (value) {
    case '0':
      return 'Enum.AdStrength\'Unrated\'';
    case '1':
      return 'Enum.AdStrength\'Poor\'';
    case '2':
      return 'Enum.AdStrength\'Average\'';
    case '3':
      return 'Enum.AdStrength\'Good\'';
    case '4':
      return 'Enum.AdStrength\'Excellent\'';
    }
  },
  'Campaign/Status': function(value) {
    return fromLegacy(value, 'CampaignStatus');
  },
  'CampaignStatus': function(value) {
    return fromLegacy(value, 'CampaignStatus');
  },

  'AdGroup/Status': function (value) {
    return fromLegacy(value, 'AdGroupStatus');
  },

  'AdExtension/Status': function(value) {
    switch(value) {
      case '108':
        return 'Enum.AdExtensionStatus\'Active\'';
      case '110':
        return 'Enum.AdExtensionStatus\'Deleted\'';
    }
  },

  //ads, keywords
  Status: function (value, entityType) {
    switch (entityType) {
    case 'Campaign':
      return fromLegacy(value, 'CampaignStatus');

    case 'AdGroup':
    case 'AdGroups':
      return fromLegacy(value, 'AdGroupStatus');

    case 'Keyword':
      return fromLegacy(value, 'OrderItemStatus');

    case 'Ad':
      // AdStatus
      switch (value) {
      case '0':
        return 'Enum.AdStatus\'Inactive\'';
      case '1':
        return 'Enum.AdStatus\'Active\'';
      case '2':
        return 'Enum.AdStatus\'Paused\'';
      case '3':
        return 'Enum.AdStatus\'Deleted\'';
      }
      break;

    case 'Goal':
      // ConversionGoalStatus
      switch (value) {
      case 'Active':
        return 'Enum.GoalStatus\'Active\'';
      case 'Paused':
        return 'Enum.GoalStatus\'Paused\'';
      }
      break;

    // https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FBingAds.Api%2FBingAds.Api.Model%2FBulkEdit%2FMtGridColumnLookups.cs&version=GBmaster&_a=contents&line=290&lineStyle=plain&lineEnd=290&lineStartColumn=17&lineEndColumn=165
    case 'AudienceAssociation':
    case 'AdGroupAudienceAssociation':
    // https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FBingAds.Api%2FBingAds.Api.Model%2FBulkEdit%2FMtGridColumnLookups.cs&version=GBmaster&_a=contents&line=305&lineStyle=plain&lineEnd=305&lineStartColumn=17&lineEndColumn=169
    case 'AdGroupAudienceCriterionWithBI':
      return fromLegacy(value, 'AdGroupCriterionStatus');
    // https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT/pullrequest/753364?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FAggregatorService%2FDataAggregator%2FGetAudienceAssociationsWithBIData%2FAudienceAssociationsWithBiDataSortAndFilter.cs&_a=overview
    case 'AudienceCriterionWithBI':
      return fromLegacy(value, 'AdGroupCriterionStatus');
    }
  },

  // TODO: idealy we should have only one of Status or AudienceStatus
  'AudienceStatus': function (value, entityType) {
    switch (entityType) {
    // https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FBingAds.Api%2FBingAds.Api.Model%2FBulkEdit%2FMtGridColumnLookups.cs&version=GBmaster&_a=contents&line=290&lineStyle=plain&lineEnd=290&lineStartColumn=17&lineEndColumn=165
    case 'AudienceAssociation':
    case 'AdGroupAudienceAssociation':
    // https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FBingAds.Api%2FBingAds.Api.Model%2FBulkEdit%2FMtGridColumnLookups.cs&version=GBmaster&_a=contents&line=305&lineStyle=plain&lineEnd=305&lineStartColumn=17&lineEndColumn=169
    case 'AdGroupAudienceCriterionWithBI':
      return fromLegacy(value, 'AdGroupCriterionStatus');
    // https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT/pullrequest/753364?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FAggregatorService%2FDataAggregator%2FGetAudienceAssociationsWithBIData%2FAudienceAssociationsWithBiDataSortAndFilter.cs&_a=overview
    case 'AudienceCriterionWithBI':
      return fromLegacy(value, 'AdGroupCriterionStatus');
    }
  },

  'TrackingStatus': function(value, entityType) {
    switch (entityType) {
    // RemessagingAudience is used for only rule-based remarketing lists when Custom Audience pilot is not enabled,
    // while Audience is used for all types of Audiences when Custom Audience pilot is enabled.
    case 'RemessagingAudience':
    case 'Audience':
    case 'Tag':
      // UETTagTrackingStatus
      switch(value) {
      case 'Unverified':
        return 'Enum.TagTrackingStatus\'Unverified\'';
      case 'Active':
        return 'Enum.TagTrackingStatus\'Active\'';
      case 'Inactive':
        return 'Enum.TagTrackingStatus\'Inactive\'';
      }
      break;

    case 'Goal':
      // ConversionGoalTrackingStatus
      switch(value) {
      case 'Unverified':
        return 'Enum.GoalTrackingStatus\'Unverified\'';
      case 'NoRecentConversion':
        return 'Enum.GoalTrackingStatus\'NoRecentConversion\'';
      case 'RecordingConversions':
        return 'Enum.GoalTrackingStatus\'RecordingConversions\'';
      case 'TagInactive':
        return 'Enum.GoalTrackingStatus\'TagInactive\'';
      }
      break;
    }
  },

  Condition: function(value, entityType) {
    switch(entityType) {
    case 'ProductOffer':
      switch(value) {
        case '0':
          return 'New';
        case '1':
          return 'Refurbished';
        case '2':
          return 'Used';
      }
      break;
    }
  }
}
